// Side Menu has: 1- Logo (clicable) 2-tabs (icone - title) 3- toggle (half close)
import React, { Component } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Collapse,
  Button,
  Container,
} from "reactstrap";
import "./SideMenu.css";
import { SideNavs, SideNavsEn } from "./route_SideMenu";
import { Link } from "react-router-dom";
import logo from "../../../Assets/Images/logoWihte.png";
import cookie from "react-cookies";
import { API_ENDPOINT, routePath } from "../../../AppConfig";
import axios from "axios";
import { connect } from "react-redux";
// import {init} from '../../../Redux/Action/socketAction'
import notification from "../../../Assets/ios_notification.mp3";
import ReactAudioPlayer from "react-audio-player";
import NotificationSystem from "react-notification-system";
import { FETCH_LOGIN_SUCCESS } from "../../../Redux/Action/type";
import { updateUser } from "../../../Redux/Action/LoginAction";
import { bindActionCreators } from "redux";

const badgeColor = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
  "light",
];
let badgeColorIndex = 0;

let CurrentUser = null;
class SideMenu extends Component {
  notificationSystem = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      contactUsRole: 31,
      TalentRole: 19,
      organizationRole: 20,

      direction: false, //ar
      flag: true,
      toggle: false,
      collapsemenu: false,
      textItem: "",
      smallScreen: false,
      scrolFlag: false,
      tooltipOpen_Mail: false,
      SidemnuBG: localStorage.getItem("SidemnuBG"),
      availtableTabs: [],
      newClientsSocket: 0,
      newDriverSocket: 0,
      // newTripsSocket:0,
      SideNavs,
      SideNavsEn,
      initTabs: false,
      ContactusCount: this.props.contact_us_count,
      prevContactusCount:
        this.props.contact_us_count === 0 ? null : this.props.contact_us_count,
      talentCount: this.props.talentCount,
      prevTalentCount:
        this.props.talentCount === 0 ? null : this.props.talentCount,
      organizationCount: this.props.organizationCount,
      prevOrganizationCount:
        this.props.organizationCount === 0
          ? null
          : this.props.organizationCount,

      orderTalentCount: this.props.orderTalentCount,
      prevOrderTalentCount:
        this.props.orderTalentCount === 0 ? null : this.props.orderTalentCount,
    };

    this.toggle = this.toggle.bind(this);
    this.togglemenu = this.togglemenu.bind(this);
    this.setTextitem = this.setTextitem.bind(this);
    this.toolTiptoggle_Mail = this.toolTiptoggle_Mail.bind(this);
  }
  NewOrganization() {
    if (
      this.state.prevOrganizationCount !== null &&
      this.state.prevOrganizationCount !== this.props.organizationCount &&
      this.state.audioflag === false
    ) {
      this.setState({
        prevOrganizationCount: this.props.organizationCount,
        audioflag: true,
      });
    }
  }
  NewContactUs() {
    if (
      this.state.prevContactusCount !== null &&
      this.state.prevContactusCount !== this.props.contact_us_count &&
      this.state.audioflag === false
    ) {
      this.setState({
        prevContactusCount: this.props.contact_us_count,
        audioflag: true,
      });
    }
  }
  NewTalent() {
    if (
      this.state.prevTalentCount !== null &&
      this.state.prevTalentCount !== this.props.talentCount &&
      this.state.audioflag === false
    ) {
      this.setState({
        prevTalentCount: this.props.talentCount,
        audioflag: true,
      });
    }
  }
  NewTalentOrder() {
    if (
      this.state.prevOrderTalentCount !== null &&
      this.state.prevOrderTalentCount !== this.props.orderTalentCount &&
      this.state.audioflag === false
    ) {
      this.setState({
        prevOrderTalentCount: this.props.orderTalentCount,
        audioflag: true,
      });
    }
  }
  addNotification = (msg) => {
    const notification = this.notificationSystem.current;
    notification.addNotification({
      title: "My ticket",
      message: msg[this.props.lang],
      level: "warning",
      position: "br",
      // autoDismiss: 15000
    });
  };
  runAudio() {
    if (this.state.audioflag === true) {
      setTimeout(() => {
        this.setState({ audioflag: false });
      }, 4000);
    }
  }
  togglemenu() {
    this.setState((state) => ({ collapsemenu: !state.collapsemenu }));
  }

  getbadgeColor() {
    if (badgeColorIndex === badgeColor.length) {
      badgeColorIndex = 0;
    }
    return badgeColor[badgeColorIndex++];
  }
  toolTiptoggle_Mail() {
    this.setState({
      tooltipOpen_Mail: !this.state.tooltipOpen_Mail,
    });
  }
  setTextitem(text) {
    this.setState({ textItem: text });
  }
  toggle() {
    this.setState((state) => ({ toggle: !state.toggle }));
  }
  handelToggleSideMenu = () => {
    if (window.innerWidth < 766) {
      this.setState(
        { flag: !this.state.flag, smallScreen: !this.state.smallScreen },
        () => {
          this.props.handeltoggle(this.state.flag);
        }
      );
    } else {
      this.setState({ flag: !this.state.flag }, () => {
        this.props.handeltoggle(this.state.flag);
      });
    }
  };

  UNSAFE_componentWillMount() {
    this.setState({ SideNavs: SideNavs, SideNavsEn: SideNavsEn });

    if (window.innerWidth < 766) {
      this.setState({ smallScreen: true, flag: false });
    }
    let UserType = sessionStorage.getItem("TicketUser");

    // CurrentUser = cookie.load("My-Ticketuser");
    CurrentUser = JSON.parse(sessionStorage.getItem("My-Ticketuser"));

    this.getAllRoles();
  }

  async getAllRoles() {
    this.setState({ initTabs: false });
    CurrentUser = JSON.parse(sessionStorage.getItem("My-Ticketuser"));

    if (
      CurrentUser !== null &&
      CurrentUser.type &&
      CurrentUser.type === "SUB_ADMIN"
    ) {
      let availtableTabsTemp = [];
      for (let i = 0; i < CurrentUser.rules.length; i++) {
        let uri = `${API_ENDPOINT}/assigRule/${
          CurrentUser.rules[i].id
            ? CurrentUser.rules[i].id
            : CurrentUser.rules[i]
        }`;


        axios
          .get(uri, {
            headers: {
              Authorization: `Bearer ${this.props.token}`,
            },
          })
          .then((response) => {
            availtableTabsTemp.push(response.data.rule.number);
            if (CurrentUser.rules.length === availtableTabsTemp.length)
              this.handleNewTabs(availtableTabsTemp);
          })
          .catch((error) => {
          });
      }
    }
  }
  handleNewTabs = (availtableTabsTemp) => {
    let arrAR = { ...this.state.SideNavs };
    let arrEN = { ...this.state.SideNavsEn };

    let arr1 = arrAR.items.filter((item, indx) => {
      if (
        item.roleNumber === -1 ||
        availtableTabsTemp.includes(item.roleNumber) === true
      ) {
        return item;
      } else if (item.childrens) {
        let childArr = [];
        childArr.push(
          item.childrens.filter((child, indChild) => {
            if (
              child.roleNumber === -1 ||
              availtableTabsTemp.includes(child.roleNumber) === true
            )
              return child;
          })
        );
        if (childArr[0].length > 0) {
          item.childrens = childArr[0];
          return item;
        }
      }
    });

    let arr2 = arrEN.items.filter((item, indx) => {
      if (
        item.roleNumber === -1 ||
        availtableTabsTemp.includes(item.roleNumber) === true
      ) {
        return item;
      } else if (item.childrens) {
        let childArr = [];
        childArr.push(
          item.childrens.filter((child, indChild) => {
            if (
              child.roleNumber === -1 ||
              availtableTabsTemp.includes(child.roleNumber) === true
            )
              return child;
          })
        );
        if (childArr[0].length > 0) {
          item.childrens = childArr[0];
          return item;
        }
      }
    });
    let obj1 = {
      items: arr1,
    };
    let obj2 = {
      items: arr2,
    };
    this.setState({
      SideNavs: obj1,
      SideNavsEn: obj2,
      initTabs: true,
    });

    
  };

  componentDidMount() {}

  handelenterMouse = () => {
    this.setState({ scrolFlag: true });
  };
  handelleaveMouse = () => {
    this.setState({ scrolFlag: false });
  };

  render() {
    badgeColorIndex = 0;
    let layoutSide = this.props.sideMenu;
    var color = this.state.SidemnuBG
      ? this.state.SidemnuBG.includes("#")
      : false;
    if (layoutSide && layoutSide !== this.state.SidemnuBG) {
      this.setState({ SidemnuBG: layoutSide });
      color = layoutSide.includes("#");
    }
   
    if (this.props.user.type === "ADMIN") {
      if (
        this.props.contact_us_count !== null &&
        this.props.contact_us_count > 0 &&
        this.props.contact_us_count !== this.state.prevContactusCount
      ) {
        this.addNotification({
          ar: "يوجد رسالة جديدة في تواصل معنا",
          en: "New Contact Us massage comming",
        });
        this.setState({
          prevContactusCount: this.props.contact_us_count,
          path: `${routePath}/PreviewChat`,
          audioflag: true,
        });
      }
    } else {
      if (this.state.availtableTabs.includes(this.state.contactUsRole)) {
        if (
          this.props.contact_us_count > 0 &&
          this.props.contact_us_count !== this.state.prevContactusCount
        ) {
          this.addNotification({
            ar: "يوجد رسالة جديدة في تواصل معنا",
            en: "New Contact Us massage comming",
          });
          this.setState({
            prevContactusCount: this.props.contact_us_count,
            path: `${routePath}/PreviewChat`,
            audioflag: true,
          });
        }
      }
    }

    if (this.props.user.type === "ADMIN") {
      if (
        this.props.organizationCount &&
        this.props.organizationCount > 0 &&
        this.props.organizationCount !== this.state.prevOrganizationCount
      ) {
        this.addNotification({
          ar: "تم إضافة منشأ جديدة ",
          en: "New Organization added",
        });
        this.setState({
          prevOrganizationCount: this.props.organizationCount,
          path: `${routePath}/Corporation`,
          audioflag: true,
        });
      }
    } else {
      if (this.state.availtableTabs.includes(this.state.organizationRole)) {
        if (
          this.props.organizationCount &&
          this.props.organizationCount > 0 &&
          this.props.organizationCount !== this.state.prevOrganizationCount
        ) {
          this.addNotification({
            ar: "تم إضافة منشأ جديدة ",
            en: "New Organization added",
          });
          this.setState({
            prevOrganizationCount: this.props.organizationCount,
            path: `${routePath}/Corporation`,
            audioflag: true,
          });
        }
      }
    }

    if (this.props.user.type === "ADMIN") {
      if (
        this.props.talentCount > 0 &&
        this.props.talentCount !== this.state.prevTalentCount
      ) {
        this.addNotification({
          ar: "تم إضافة موهوب جديد",
          en: "New Talent comming",
        });
        this.setState({
          prevTalentCount: this.props.talentCount,
          path: `${routePath}/Talents`,
          audioflag: true,
        });
      }
      if (
        this.props.orderTalentCount > 0 &&
        this.props.orderTalentCount !== this.state.prevOrderTalentCount
      ) {
        this.addNotification({
          ar: "تم إضافة طلب لموهوب ",
          en: "New Talent Order comming",
        });
        this.setState({
          prevOrderTalentCount: this.props.orderTalentCount,
          path: `${routePath}/ViewTalentOrder`,
          audioflag: true,
        });
      }
    } else {
      if (this.state.availtableTabs.includes(this.state.TalentRole)) {
        if (
          this.props.talentCount > 0 &&
          this.props.talentCount !== this.state.prevTalentCount
        ) {
          this.addNotification({
            ar: "تم إضافة موهوب جديد",
            en: "New Talent comming",
          });
          this.setState({
            prevTalentCount: this.props.talentCount,
            path: `${routePath}/Talents`,
            audioflag: true,
          });
        }
        if (
          this.props.orderTalentCount > 0 &&
          this.props.orderTalentCount !== this.state.prevOrderTalentCount
        ) {
          this.addNotification({
            ar: "تم إضافة طلب لموهوب ",
            en: "New Talent Order comming",
          });
          this.setState({
            prevOrderTalentCount: this.props.orderTalentCount,
            path: `${routePath}/ViewTalentOrder`,
            audioflag: true,
          });
        }
      }
    }
    //updates user
    if (
      this.props.updatedUser !== null &&
      this.props.updatedUser.rules != this.props.user.rules
    ) {
      sessionStorage.setItem(
        "My-Ticketuser",
        JSON.stringify(this.props.updatedUser)
      );
      // this.getAllRoles();
      this.props.updateUser(this.props.updatedUser);
    }

    let direction = this.props.direction;

    return (
      <div
        className={
          !direction
            ? this.state.smallScreen && this.state.flag
              ? "sidemenueclose"
              : !this.state.flag
              ? "sidemenueclose side-en sideMenu"
              : "sidemenueopen side-en sideMenu"
            : this.state.smallScreen && this.state.flag
            ? "sidemenueclose"
            : !this.state.flag
            ? "sidemenueclose side-ar sideMenu"
            : "sidemenueopen side-ar sideMenu"
        }
      >
        <Link to={this.state.path}>
          <NotificationSystem ref={this.notificationSystem} id="notifi" />
        </Link>
        <Button
          id="toggleSideMenuBtn"
          onClick={this.handelToggleSideMenu}
          className={
            !direction
              ? this.state.smallScreen && this.state.flag
                ? "sidecloseenBTN"
                : !this.state.flag
                ? "sidecloseenBTN"
                : "sideopenenBTN"
              : this.state.smallScreen && this.state.flag
              ? "sideclosearBTN"
              : !this.state.flag
              ? "sideclosearBTN"
              : "sideopenarBTN"
          }
        >
          <i className="fas fa-bars"></i>
        </Button>

        <div
          className={`${this.state.SidemnuBG} sideMenuContentStyle`}
          onMouseEnter={this.handelenterMouse}
          onMouseLeave={this.handelleaveMouse}
        >
          <div
            className="sideMenuContentStyleOvelay"
            style={{
              backgroundColor: color
                ? this.state.SidemnuBG
                  ? this.state.SidemnuBG
                  : "#1E1E1E"
                : "",
            }}
          >
            <Container>
              <Row style={{ textAlign: direction ? "right" : "left" }}>
                <Col lg="12" md="12" className="p-0 m-0 mb-3 d-flex">
                  <Link
                    to={"/MyTicket/Dashboard"}
                    className="text-center"
                    style={{ margin: "0 auto" }}
                  >
                    <img
                      src={logo}
                      style={{
                        width: "100%",
                        transition: "all 0.6s ease",
                        margin: "30px 0px 0",
                        paddingBottom: "30px",
                      }}
                      alt="Logo"
                    />
                  </Link>
                </Col>
                <Col
                  lg="12"
                  md="12"
                  className={this.state.flag ? "m-0 mb-2 " : "m-0 mb-2 "}
                >
                  <Row className={"sideMenu-scroll"}>
                    {direction
                      ? this.state.SideNavs &&
                        this.state.SideNavs.items &&
                        this.state.SideNavs.items.length > 0 &&
                        this.state.SideNavs.items.map((text, index) => {
                          return this.props.token ? (
                            CurrentUser.type === "ADMIN" ? (
                              text.childrens ? (
                                <Col
                                  lg="12"
                                  className="headerBorder headerBorderar pb-2"
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      this.state.textItem === text &&
                                      this.state.toggle
                                        ? "rgba(30, 30, 30,.6)"
                                        : "",
                                    display: "block",
                                    marginBottom: this.state.flag
                                      ? ""
                                      : "1.5rem",
                                    paddingRight: "6px",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  <h5
                                    id={this.state.flag ? "" : "centerIcons"}
                                    onClick={() => {
                                      this.toggle();
                                      this.togglemenu();
                                      this.setTextitem(text);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {/* <Row> */}
                                    <div lg="9" md="9" sm="11" xs="11">
                                      <i
                                        style={{
                                          color: "#fffe",
                                          paddingLeft: "4px",
                                          display:
                                            this.state.smallScreen &&
                                            !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                        }}
                                        className={text.icon}
                                      ></i>
                                      <span
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                          fontSize: "14px",
                                          color: "#ffffffcc",
                                        }}
                                      >
                                        {text.name}
                                      </span>{" "}
                                      &nbsp;&nbsp;
                                      {text.name === "المواهب" &&
                                      this.props.talentCount !== null &&
                                      this.props.talentCount > 0 ? (
                                        <span
                                          style={{
                                            backgroundColor: "#ea5a4f",
                                            color: "white",
                                            padding: "3px",
                                            borderRadius: "2px",
                                          }}
                                        >
                                          {this.state.prevTalentCount}
                                        </span>
                                      ) : null}
                                      &nbsp;
                                      {text.name === "المواهب" &&
                                      this.props.orderTalentCount !== null &&
                                      this.props.orderTalentCount > 0 ? (
                                        <span
                                          style={{
                                            backgroundColor: "#ea5a4f",
                                            color: "white",
                                            padding: "3px",
                                            borderRadius: "2px",
                                          }}
                                        >
                                          {this.state.prevOrderTalentCount}
                                        </span>
                                      ) : null}
                                    </div>
                                    <div
                                      className="fixWidthIcon px-0"
                                      lg="2"
                                      md="2"
                                      sm="1"
                                      xs="1"
                                    >
                                      <i
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                        }}
                                        className={
                                          this.state.textItem === text &&
                                          this.state.toggle
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                        }
                                      ></i>
                                    </div>
                                    {/* </Row> */}
                                  </h5>
                                  <Collapse
                                    isOpen={
                                      this.state.collapsemenu &&
                                      text === this.state.textItem
                                    }
                                  >
                                    <Card>
                                      <CardBody>
                                        <ul
                                          className={
                                            direction ? "mr-4" : "ml-4"
                                          }
                                        >
                                          {text.childrens.map((child, ind) => (
                                            <li>
                                              <Link
                                                style={{ color: "#fff" }}
                                                to={{
                                                  pathname: child.url,
                                                  state: child.state,
                                                }}
                                              >
                                                {" "}
                                                {child.name}{" "}
                                              </Link>{" "}
                                              &nbsp;&nbsp;
                                              {child.name === "المواهب" &&
                                              this.props.talentCount !== null &&
                                              this.props.talentCount > 0 ? (
                                                <span
                                                  style={{
                                                    backgroundColor: "#ea5a4f",
                                                    color: "white",
                                                    padding: "3px",
                                                    borderRadius: "2px",
                                                  }}
                                                >
                                                  {this.state.prevTalentCount}
                                                </span>
                                              ) : null}
                                              &nbsp;
                                              {child.name ===
                                                " الطلبات علي الموهوبين" &&
                                              this.props.orderTalentCount !==
                                                null &&
                                              this.props.orderTalentCount >
                                                0 ? (
                                                <span
                                                  style={{
                                                    backgroundColor: "#ea5a4f",
                                                    color: "white",
                                                    padding: "3px",
                                                    borderRadius: "2px",
                                                  }}
                                                >
                                                  {
                                                    this.state
                                                      .prevOrderTalentCount
                                                  }
                                                </span>
                                              ) : null}
                                            </li>
                                          ))}
                                        </ul>
                                      </CardBody>
                                    </Card>
                                  </Collapse>
                                </Col>
                              ) : (
                                <Col
                                  lg="12"
                                  className="pb-2"
                                  style={{
                                    marginBottom: this.state.flag
                                      ? ""
                                      : "1.5rem",
                                    paddingRight: "6px",
                                    paddingLeft: "6px",
                                  }}
                                >
                                  <Link
                                    id={this.state.flag ? "" : "centerIcons"}
                                    to={{ pathname: text.url }}
                                  >
                                    <i
                                      style={{
                                        color: "#fffffe",
                                        paddingLeft: "4px",
                                        display:
                                          this.state.smallScreen &&
                                          !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                      }}
                                      className={text.icon}
                                    ></i>
                                    <span
                                      style={{
                                        display: !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                        fontSize: "14px",
                                        color: "#ffffffcc",
                                      }}
                                      onClick={() => {
                                        this.setState(
                                          { collapsemenu: false },
                                          () => {
                                            this.setTextitem(text);
                                          }
                                        );
                                      }}
                                    >
                                      {text.name}
                                    </span>{" "}
                                    &nbsp;&nbsp;
                                    {text.name === "المنشأت" &&
                                    this.props.organizationCount !== null &&
                                    this.props.organizationCount > 0 ? (
                                      <span
                                        style={{
                                          backgroundColor: "#ea5a4f",
                                          color: "white",
                                          padding: "3px",
                                          borderRadius: "2px",
                                        }}
                                      >
                                        {this.state.prevOrganizationCount}
                                      </span>
                                    ) : text.name === "تواصل معنا" &&
                                      this.props.contact_us_count !== null &&
                                      this.props.contact_us_count > 0 ? (
                                      <span
                                        style={{
                                          backgroundColor: "#ea5a4f",
                                          color: "white",
                                          padding: "3px",
                                          borderRadius: "2px",
                                        }}
                                      >
                                        {this.props.contact_us_count}
                                      </span>
                                    ) : null}
                                  </Link>
                                </Col>
                              )
                            ) : this.state.initTabs === true ? (
                              text.childrens ? (
                                text.roleNumber ? (
                                  <Col
                                    lg="12"
                                    className="headerBorder headerBorderen pb-2"
                                    key={index}
                                    style={{
                                      backgroundColor:
                                        this.state.textItem === text &&
                                        this.state.toggle
                                          ? "rgba(30, 30, 30,.6)"
                                          : "",
                                      display: "block",
                                      marginBottom: this.state.flag
                                        ? ""
                                        : "1.5rem",
                                      paddingRight: "15px",
                                      paddingLeft: "6px",
                                    }}
                                  >
                                    <h5
                                      id={this.state.flag ? "" : "centerIcons"}
                                      onClick={() => {
                                        this.toggle();
                                        this.togglemenu();
                                        this.setTextitem(text);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {/* <Row> */}
                                      <div lg="9" md="9" sm="11" xs="11">
                                        <i
                                          style={{
                                            color: "#fffe",
                                            paddingRight: "4px",
                                            display:
                                              this.state.smallScreen &&
                                              !this.state.flag
                                                ? "none"
                                                : "inline-block",
                                          }}
                                          className={text.icon}
                                        ></i>
                                        <span
                                          style={{
                                            display: !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                            fontSize: "14px",
                                            color: "#ffffffcc",
                                          }}
                                        >
                                          {text.name}
                                        </span>
                                      </div>
                                      <div
                                        className="fixWidthIcon"
                                        lg="2"
                                        md="2"
                                        sm="1"
                                        xs="1"
                                      >
                                        <i
                                          style={{
                                            display: !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                          }}
                                          className={
                                            this.state.textItem === text &&
                                            this.state.toggle
                                              ? "fa fa-chevron-up"
                                              : "fa fa-chevron-down"
                                          }
                                        ></i>
                                      </div>
                                      {/* </Row> */}
                                    </h5>
                                    <Collapse
                                      isOpen={
                                        this.state.collapsemenu &&
                                        text === this.state.textItem
                                      }
                                    >
                                      <Card>
                                        <CardBody>
                                          <ul
                                            className={
                                              direction ? "mr-4" : "ml-4"
                                            }
                                          >
                                            {text.childrens.map(
                                              (child, ind) => (
                                                <li>
                                                  <Link
                                                    style={{ color: "#fff" }}
                                                    to={{
                                                      pathname: child.url,
                                                      state: child.state,
                                                    }}
                                                  >
                                                    {" "}
                                                    {child.name}{" "}
                                                  </Link>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </CardBody>
                                      </Card>
                                    </Collapse>
                                  </Col>
                                ) : (
                                  <Col
                                    lg="12"
                                    className="headerBorder headerBorderar pb-2"
                                    key={index}
                                    style={{
                                      backgroundColor:
                                        this.state.textItem === text &&
                                        this.state.toggle
                                          ? "rgba(30, 30, 30,.6)"
                                          : "",
                                      display: "block",
                                      marginBottom: this.state.flag
                                        ? ""
                                        : "1.5rem",
                                      paddingRight: "6px",
                                      paddingLeft: "15px",
                                    }}
                                  >
                                    <h5
                                      id={this.state.flag ? "" : "centerIcons"}
                                      onClick={() => {
                                        this.toggle();
                                        this.togglemenu();
                                        this.setTextitem(text);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {/* <Row> */}
                                      <div lg="9" md="9" sm="11" xs="11">
                                        <i
                                          style={{
                                            color: "#fffe",
                                            paddingLeft: "4px",
                                            display:
                                              this.state.smallScreen &&
                                              !this.state.flag
                                                ? "none"
                                                : "inline-block",
                                          }}
                                          className={text.icon}
                                        ></i>
                                        <span
                                          style={{
                                            display: !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                            fontSize: "14px",
                                            color: "#ffffffcc",
                                          }}
                                        >
                                          {text.name}
                                        </span>
                                      </div>
                                      <div
                                        className="fixWidthIcon px-0"
                                        lg="2"
                                        md="2"
                                        sm="1"
                                        xs="1"
                                      >
                                        <i
                                          style={{
                                            display: !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                          }}
                                          className={
                                            this.state.textItem === text &&
                                            this.state.toggle
                                              ? "fa fa-chevron-up"
                                              : "fa fa-chevron-down"
                                          }
                                        ></i>
                                      </div>
                                      {/* </Row> */}
                                    </h5>
                                    <Collapse
                                      isOpen={
                                        this.state.collapsemenu &&
                                        text === this.state.textItem
                                      }
                                    >
                                      <Card>
                                        <CardBody>
                                          <ul
                                            className={
                                              direction ? "mr-4" : "ml-4"
                                            }
                                          >
                                            {text.childrens.map(
                                              (child, ind) => (
                                                <li>
                                                  <Link
                                                    style={{ color: "#fff" }}
                                                    to={{
                                                      pathname: child.url,
                                                      state: child.state,
                                                    }}
                                                  >
                                                    {" "}
                                                    {child.name}{" "}
                                                  </Link>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </CardBody>
                                      </Card>
                                    </Collapse>
                                  </Col>
                                )
                              ) : (
                                <Col
                                  lg="12"
                                  className="pb-2"
                                  style={{
                                    marginBottom: this.state.flag
                                      ? ""
                                      : "1.5rem",
                                    paddingRight: "6px",
                                    paddingLeft: "6px",
                                  }}
                                >
                                  <Link
                                    id={this.state.flag ? "" : "centerIcons"}
                                    to={{ pathname: text.url }}
                                  >
                                    <i
                                      style={{
                                        color: "#fffffe",
                                        paddingLeft: "4px",
                                        display:
                                          this.state.smallScreen &&
                                          !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                      }}
                                      className={text.icon}
                                    ></i>

                                    <span
                                      style={{
                                        display: !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                        fontSize: "14px",
                                        color: "#ffffffcc",
                                      }}
                                      onClick={() => {
                                        this.setState(
                                          { collapsemenu: false },
                                          () => {
                                            this.setTextitem(text);
                                          }
                                        );
                                      }}
                                    >
                                      {text.name}
                                    </span>
                                  </Link>
                                </Col>
                              )
                            ) : null
                          ) : null;
                        })
                      : this.state.SideNavsEn &&
                        this.state.SideNavsEn.items.length > 0 &&
                        this.state.SideNavsEn.items.map((text, index) => {
                          return CurrentUser.type === "ADMIN" ? (
                            text.childrens ? (
                              <Col
                                lg="12"
                                className="headerBorder headerBorderen pb-2"
                                key={index}
                                style={{
                                  backgroundColor:
                                    this.state.textItem === text &&
                                    this.state.toggle
                                      ? "rgba(30, 30, 30,.6)"
                                      : "",
                                  display: "block",
                                  marginBottom: this.state.flag ? "" : "1.5rem",
                                  paddingRight: "15px",
                                  paddingLeft: "6px",
                                }}
                              >
                                <h5
                                  id={this.state.flag ? "" : "centerIcons"}
                                  onClick={() => {
                                    this.toggle();
                                    this.togglemenu();
                                    this.setTextitem(text);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {/* <Row> */}
                                  <div lg="9" md="9" sm="11" xs="11">
                                    <i
                                      style={{
                                        color: "#fffe",
                                        paddingRight: "4px",
                                        display:
                                          this.state.smallScreen &&
                                          !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                      }}
                                      className={text.icon}
                                    ></i>
                                    <span
                                      style={{
                                        display: !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                        fontSize: "14px",
                                        color: "#ffffffcc",
                                      }}
                                    >
                                      {text.name}
                                    </span>{" "}
                                    &nbsp;&nbsp;
                                    {text.name === "Talent" &&
                                    this.props.talentCount !== null &&
                                    this.props.talentCount > 0 ? (
                                      <span
                                        style={{
                                          backgroundColor: "#ea5a4f",
                                          color: "white",
                                          padding: "3px",
                                          borderRadius: "2px",
                                        }}
                                      >
                                        {this.state.prevTalentCount}
                                      </span>
                                    ) : null}
                                    &nbsp;
                                    {text.name === "Talent" &&
                                    this.props.orderTalentCount !== null &&
                                    this.props.orderTalentCount > 0 ? (
                                      <span
                                        style={{
                                          backgroundColor: "#ea5a4f",
                                          color: "white",
                                          padding: "3px",
                                          borderRadius: "2px",
                                        }}
                                      >
                                        {this.state.prevOrderTalentCount}
                                      </span>
                                    ) : null}
                                  </div>
                                  <div
                                    className="fixWidthIcon"
                                    lg="2"
                                    md="2"
                                    sm="1"
                                    xs="1"
                                  >
                                    <i
                                      style={{
                                        display: !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                      }}
                                      className={
                                        this.state.textItem === text &&
                                        this.state.toggle
                                          ? "fa fa-chevron-up"
                                          : "fa fa-chevron-down"
                                      }
                                    ></i>
                                  </div>
                                  {/* </Row> */}
                                </h5>
                                <Collapse
                                  isOpen={
                                    this.state.collapsemenu &&
                                    text === this.state.textItem
                                  }
                                >
                                  <Card>
                                    <CardBody>
                                      <ul
                                        className={direction ? "mr-4" : "ml-4"}
                                      >
                                        {text.childrens.map((child, ind) => (
                                          <li>
                                            <Link
                                              style={{ color: "#fff" }}
                                              to={{
                                                pathname: child.url,
                                                state: child.state,
                                              }}
                                            >
                                              {" "}
                                              {child.name}{" "}
                                            </Link>{" "}
                                            &nbsp;&nbsp;
                                            {child.name === "Talent" &&
                                            this.props.talentCount !== null &&
                                            this.props.talentCount > 0 ? (
                                              <span
                                                style={{
                                                  backgroundColor: "#ea5a4f",
                                                  color: "white",
                                                  padding: "3px",
                                                  borderRadius: "2px",
                                                }}
                                              >
                                                {this.state.prevTalentCount}
                                              </span>
                                            ) : null}
                                            &nbsp;
                                            {child.name ===
                                              "Talents's Orders" &&
                                            this.props.orderTalentCount !==
                                              null &&
                                            this.props.orderTalentCount > 0 ? (
                                              <span
                                                style={{
                                                  backgroundColor: "#ea5a4f",
                                                  color: "white",
                                                  padding: "3px",
                                                  borderRadius: "2px",
                                                }}
                                              >
                                                {
                                                  this.state
                                                    .prevOrderTalentCount
                                                }
                                              </span>
                                            ) : null}
                                          </li>
                                        ))}
                                      </ul>
                                    </CardBody>
                                  </Card>
                                </Collapse>
                              </Col>
                            ) : (
                              <Col
                                lg="12"
                                className="pb-2"
                                style={{
                                  marginBottom: this.state.flag ? "" : "1.5rem",
                                  paddingRight: "6px",
                                  paddingLeft: "6px",
                                }}
                              >
                                <Link
                                  id={this.state.flag ? "" : "centerIcons"}
                                  to={{ pathname: text.url }}
                                >
                                  <i
                                    style={{
                                      color: "#fffffe",
                                      paddingRight: "4px",
                                      display:
                                        this.state.smallScreen &&
                                        !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                    }}
                                    className={text.icon}
                                  ></i>
                                  <span
                                    style={{
                                      display: !this.state.flag
                                        ? "none"
                                        : "inline-block",
                                      fontSize: "14px",
                                      color: "#ffffffcc",
                                    }}
                                    onClick={() => {
                                      this.setState(
                                        { collapsemenu: false },
                                        () => {
                                          this.setTextitem(text);
                                        }
                                      );
                                    }}
                                  >
                                    {text.name}
                                  </span>{" "}
                                  &nbsp;&nbsp;
                                  {text.name === "Corporation" &&
                                  this.props.organizationCount !== null &&
                                  this.props.organizationCount > 0 ? (
                                    <span
                                      style={{
                                        backgroundColor: "#ea5a4f",
                                        color: "white",
                                        padding: "3px",
                                        borderRadius: "2px",
                                      }}
                                    >
                                      {this.state.prevOrganizationCount}
                                    </span>
                                  ) : text.name === "Contact Us" &&
                                    this.props.contact_us_count !== null &&
                                    this.props.contact_us_count > 0 ? (
                                    <span
                                      style={{
                                        backgroundColor: "#ea5a4f",
                                        color: "white",
                                        padding: "3px",
                                        borderRadius: "2px",
                                      }}
                                    >
                                      {this.props.contact_us_count}
                                    </span>
                                  ) : text.name === "Talent" &&
                                    this.props.talentCount !== null &&
                                    this.props.talentCount > 0 ? (
                                    <span
                                      style={{
                                        backgroundColor: "#ea5a4f",
                                        color: "white",
                                        padding: "3px",
                                        borderRadius: "2px",
                                      }}
                                    >
                                      {this.state.prevTalentCount}
                                    </span>
                                  ) : null}
                                  {text.name === "Talent" &&
                                  this.props.orderTalentCount !== null &&
                                  this.props.orderTalentCount > 0 ? (
                                    <span
                                      style={{
                                        backgroundColor: "#ea5a4f",
                                        color: "white",
                                        padding: "3px",
                                        borderRadius: "2px",
                                      }}
                                    >
                                      {this.state.prevOrderTalentCount}
                                    </span>
                                  ) : null}
                                </Link>
                              </Col>
                            )
                          ) : this.state.initTabs === true ? (
                            text.childrens ? (
                              text.roleNumber ? (
                                <Col
                                  lg="12"
                                  className="headerBorder headerBorderen pb-2"
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      this.state.textItem === text &&
                                      this.state.toggle
                                        ? "rgba(30, 30, 30,.6)"
                                        : "",
                                    display: "block",
                                    marginBottom: this.state.flag
                                      ? ""
                                      : "1.5rem",
                                    paddingRight: "15px",
                                    paddingLeft: "6px",
                                  }}
                                >
                                  <h5
                                    id={this.state.flag ? "" : "centerIcons"}
                                    onClick={() => {
                                      this.toggle();
                                      this.togglemenu();
                                      this.setTextitem(text);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {/* <Row> */}
                                    <div lg="9" md="9" sm="11" xs="11">
                                      <i
                                        style={{
                                          color: "#fffe",
                                          paddingRight: "4px",
                                          display:
                                            this.state.smallScreen &&
                                            !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                        }}
                                        className={text.icon}
                                      ></i>
                                      <span
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                          fontSize: "14px",
                                          color: "#ffffffcc",
                                        }}
                                      >
                                        {text.name}
                                      </span>
                                    </div>
                                    <div
                                      className="fixWidthIcon"
                                      lg="2"
                                      md="2"
                                      sm="1"
                                      xs="1"
                                    >
                                      <i
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                        }}
                                        className={
                                          this.state.textItem === text &&
                                          this.state.toggle
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                        }
                                      ></i>
                                    </div>
                                    {/* </Row> */}
                                  </h5>
                                  <Collapse
                                    isOpen={
                                      this.state.collapsemenu &&
                                      text === this.state.textItem
                                    }
                                  >
                                    <Card>
                                      <CardBody>
                                        <ul
                                          className={
                                            direction ? "mr-4" : "ml-4"
                                          }
                                        >
                                          {text.childrens.map((child, ind) => (
                                            <li>
                                              <Link
                                                style={{ color: "#fff" }}
                                                to={{
                                                  pathname: child.url,
                                                  state: child.state,
                                                }}
                                              >
                                                {" "}
                                                {child.name}{" "}
                                              </Link>
                                            </li>
                                          ))}
                                        </ul>
                                      </CardBody>
                                    </Card>
                                  </Collapse>
                                </Col>
                              ) : (
                                <Col
                                  lg="12"
                                  className="headerBorder headerBorderen pb-2"
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      this.state.textItem === text &&
                                      this.state.toggle
                                        ? "rgba(30, 30, 30,.6)"
                                        : "",
                                    display: "block",
                                    marginBottom: this.state.flag
                                      ? ""
                                      : "1.5rem",
                                    paddingRight: "15px",
                                    paddingLeft: "6px",
                                  }}
                                >
                                  <h5
                                    id={this.state.flag ? "" : "centerIcons"}
                                    onClick={() => {
                                      this.toggle();
                                      this.togglemenu();
                                      this.setTextitem(text);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {/* <Row> */}
                                    <div lg="9" md="9" sm="11" xs="11">
                                      <i
                                        style={{
                                          color: "#fffe",
                                          paddingRight: "4px",
                                          display:
                                            this.state.smallScreen &&
                                            !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                        }}
                                        className={text.icon}
                                      ></i>
                                      <span
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                          fontSize: "14px",
                                          color: "#ffffffcc",
                                        }}
                                      >
                                        {text.name}
                                      </span>
                                    </div>
                                    <div
                                      className="fixWidthIcon"
                                      lg="2"
                                      md="2"
                                      sm="1"
                                      xs="1"
                                    >
                                      <i
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                        }}
                                        className={
                                          this.state.textItem === text &&
                                          this.state.toggle
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                        }
                                      ></i>
                                    </div>
                                    {/* </Row> */}
                                  </h5>
                                  <Collapse
                                    isOpen={
                                      this.state.collapsemenu &&
                                      text === this.state.textItem
                                    }
                                  >
                                    <Card>
                                      <CardBody>
                                        <ul
                                          className={
                                            direction ? "mr-4" : "ml-4"
                                          }
                                        >
                                          {text.childrens.map((child, ind) => (
                                            <li>
                                              <Link
                                                style={{ color: "#fff" }}
                                                to={{
                                                  pathname: child.url,
                                                  state: child.state,
                                                }}
                                              >
                                                {" "}
                                                {child.name}{" "}
                                              </Link>
                                            </li>
                                          ))}
                                        </ul>
                                      </CardBody>
                                    </Card>
                                  </Collapse>
                                </Col>
                              )
                            ) : (
                              <Col
                                lg="12"
                                className="pb-2"
                                style={{
                                  marginBottom: this.state.flag ? "" : "1.5rem",
                                  paddingRight: "6px",
                                  paddingLeft: "6px",
                                }}
                              >
                                <Link
                                  id={this.state.flag ? "" : "centerIcons"}
                                  to={{ pathname: text.url }}
                                >
                                  <i
                                    style={{
                                      color: "#fffffe",
                                      paddingRight: "4px",
                                      display:
                                        this.state.smallScreen &&
                                        !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                    }}
                                    className={text.icon}
                                  ></i>

                                  <span
                                    style={{
                                      display: !this.state.flag
                                        ? "none"
                                        : "inline-block",
                                      fontSize: "14px",
                                      color: "#ffffffcc",
                                    }}
                                    onClick={() => {
                                      this.setState(
                                        { collapsemenu: false },
                                        () => {
                                          this.setTextitem(text);
                                        }
                                      );
                                    }}
                                  >
                                    {text.name}
                                  </span>
                                </Link>
                              </Col>
                            )
                          ) : null;
                        })}
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        {this.props.talentCount && this.NewTalent()}
        {this.props.orderTalentCount && this.NewTalentOrder()}
        {this.props.organizationCount && this.NewOrganization()}
        {this.props.contact_us_count && this.NewContactUs()}

        {this.state.audioflag && (
          <ReactAudioPlayer src={notification} autoPlay />
        )}
        {this.runAudio()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.userInfo.language,
    token: state.userInfo.token,
    sideMenu: state.setting.sideMenu,
    type: state.userInfo.Type,
    user: state.userInfo.user,
    contact_us_count: state.socket.contact_us_count,
    talentCount: state.socket.talentCount,
    orderTalentCount: state.socket.orderTalentCount,
    organizationCount: state.socket.organizationCount,
    updatedUser: state.socket.updatedUser,
  };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);
